import { createSlice } from '@reduxjs/toolkit';

import { VoiceMeetingStatus } from 'features/call/call-base/enums';

const initialState = {
  isAudioReady: false,
  isMicrophoneMuted: false,
  voiceMeetingStatus: VoiceMeetingStatus.DISCONNECTED,
};

export const initialAudioState = initialState;

/** Manages all audio for calls. (Except app sounds like ringtones.) */
const audioSlice = createSlice({
  name: 'audio',
  initialState,
  reducers: {
    // https://redux.js.org/style-guide/#model-actions-as-events-not-setters
    audioReady: (state) => {
      state.isAudioReady = true;
    },
    audioEnd: () => {
      return initialState;
    },

    hearingAudioReady: (state) => {
      state.voiceMeetingStatus = VoiceMeetingStatus.CONNECTED;
    },
    hearingAudioEnd: (state) => {
      state.voiceMeetingStatus = VoiceMeetingStatus.DISCONNECTED;
    },
    hearingAudioFailed: (state) => {
      state.voiceMeetingStatus = VoiceMeetingStatus.FAILED;
    },

    muteMicrophone: (state) => {
      state.isMicrophoneMuted = true;
    },
    unmuteMicrophone: (state) => {
      state.isMicrophoneMuted = false;
    },
  },
});

export const {
  audioReady,
  audioEnd,
  hearingAudioReady,
  hearingAudioEnd,
  muteMicrophone,
  unmuteMicrophone,
  hearingAudioFailed,
} = audioSlice.actions;

export const audioReducer = audioSlice.reducer;
